import { FormProps } from '@deltek/specification-client/core/Models/formProps'

export interface CopyProductForm {
    sectionNames: Partial<FormProps>
    productType: Partial<FormProps>
    specAgentProductTypeId: Partial<FormProps>
    isActive: Partial<FormProps>
    listingType: Partial<FormProps>
    state: Partial<FormProps>
    includeManufacturerOptions: Partial<FormProps>
}
export enum RadioType {
    Existing = 'existing',
    New = 'new',
}

export interface NoteRequestInput {
    listingId: string
    content: string
    productDetailNoteType: string
    reason: string
    origin?: string
}
export interface ApiInput {
    listingId: string
    productType: string
    specAgentProductTypeId?: number | null
    sectionNumber: string
    sectionTitle: string
    isActive: boolean
    type: string
    sectionName?: string
    productName: string
    productDetailNote?: NoteRequestInput
    newState: string
    includeManufacturerOptions: boolean
}
export interface ListingDataProps {
    name: string
    key: string
}

export interface CopyProductInput {
    listingId: string
    productType: string
    specAgentProductTypeId?: number | null
    sectionNumber: string
    sectionTitle: string
    sectionName?: string
    isActive: boolean
    type: string
    newState: string
    includeManufacturerOptions: boolean
}

export interface CopyProductProps {
    copyProductListing: {
        listingId: string
    }
}
export interface MoveProductInput {
    listingId: string
    productType: string
    specAgentProductTypeId?: number | null
    sectionNumber: string
    sectionTitle: string
    isActive: boolean
    type: string
    newState: string
    includeManufacturerOptions: boolean
}

export interface MoveProductProps {
    moveProductListing: {
        listingId: string
    }
}

export const ListingData = [
    { name: 'Manufacturer', key: 'firmName' },
    { name: 'Product Model number', key: 'model' },
    { name: 'Product Name', key: 'productName' },
    { name: 'Category', key: 'categories' },
    { name: 'Family', key: 'sectionName' },
    { name: 'New Family', key: 'family' },
    { name: 'Product Type', key: 'productType' },
    { name: 'New Product Type', key: 'newProductType' },
    { name: 'Listing Type', key: 'type' },
    { name: 'New Listing Type', key: 'newListingType' },
    { name: 'Status', key: 'isActive' },
    { name: 'New Product Status', key: 'newIsActive' },
    { name: 'State', key: 'submissionStatus' },
    { name: 'New State', key: 'newState' },
    { name: 'Include Manufacturer Options', key: 'includeManufacturerOptions' },
] as ListingDataProps[]
